import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatePresence } from 'framer-motion';
import { cloneElement, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useGrowlerManager } from './useGrowlerManager';
const GrowlerRenderer = () => {
    const { currentGrowler } = useGrowlerManager();
    return (_jsx(AnimatePresence, { children: currentGrowler ? cloneElement(currentGrowler) : null }));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GrowlerPortal = () => {
    const [container] = useState(() => {
        const div = document.createElement('div');
        div.id = 'growler-portal';
        return div;
    });
    useLayoutEffect(() => {
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, [container]);
    return createPortal(_jsx(GrowlerRenderer, {}), container);
};
export default GrowlerPortal;
//# sourceMappingURL=GrowlerPortal.js.map